import { render, staticRenderFns } from "./trivia_session_live_page.vue?vue&type=template&id=b6332f8a"
import script from "./trivia_session_live_page.vue?vue&type=script&lang=js"
export * from "./trivia_session_live_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports